import React from 'react';
import MainMenu from './Navigation/MainMenu';
import {connect} from 'react-redux';
import {closePushMenu} from '../../actions/PushMenu';

class PushMenu extends React.Component {
    constructor() {
        super();
        this.close = this.close.bind(this);
    }

    close() {
        this.props.dispatch(closePushMenu());
    }

    render() {
        const {active} = this.props;
        return <div>
            <div className={"push-menu" + (active ? " is-active" : "")}>
                <nav id="push-menu" className="main-menu">
                    <button onClick={this.close} className="hamburger hamburger--elastic is-active" type="button"
                            aria-label="Menu" aria-controls="navigation">
                        <span className="hamburger-box">
                            <span className="hamburger-inner" />
                        </span>
                    </button>
                    <MainMenu authenticated={this.props.authenticated} name={this.props.name}/>
                </nav>
            </div>
            <div className={"push-menu-mask" + (active ? " is-active" : "")} />
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        active: state.pushMenu.active,
        authenticated: state.auth.authenticated,
        name: state.user.userData.fullname
    }
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps)(PushMenu);


// WEBPACK FOOTER //
// ./src/components/Presentation/PushMenu.js